import React, { useCallback, useEffect, useState } from 'react'
import Tooltip from 'rc-tooltip';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { FiSearch as SearchIcon } from '@react-icons/all-files/fi/FiSearch'
import { FiLayout as SpaceIcon } from '@react-icons/all-files/fi/FiLayout'
// import { GiBackwardTime as RecentIcon } from '@react-icons/all-files/gi/GiBackwardTime'
import { FiPlus as NewRoomIcon } from '@react-icons/all-files/fi/FiPlus'
import { FiUsers as UsersIcon } from "@react-icons/all-files/fi/FiUsers"
import { FiUser as UserIcon } from "@react-icons/all-files/fi/FiUser"
import { FiEdit2 as EditIcon } from "@react-icons/all-files/fi/FiEdit2"
import { FiChevronDown as ExpandedIcon } from '@react-icons/all-files/fi/FiChevronDown'
import { FiChevronRight as CollapsedIcon } from '@react-icons/all-files/fi/FiChevronRight'
import { FaSpinner as LoadingIcon } from '@react-icons/all-files/fa/FaSpinner'
import { FiMoreHorizontal as MoreOptionsIcon } from '@react-icons/all-files/fi/FiMoreHorizontal'

import LoopApi from '../../helpers/LoopApi'
import { isJSON, moveElementToOtherArray, rearrangeElements } from '../../helpers';

import { Container, FormFieldWrapper, getItemStyle, getListStyle, Header, NoRooms, SpaceLeft, SpaceName, SpaceRight, WorkspaceAvatar, WorkspaceItem, DroppableWrapper, Bottom, Meeting as StyledMeeting, IconWrapper, XLine, RoomTooltipWrapper, OrganizationWrapper } from './styles'
import { Meeting } from './types'
import { ModalActions } from '../../stores/ModalStore';
import LoadingComponent from './Loader';
import { useHistory } from 'react-router';
import { CallingInstanceState } from '../../calling/types';
import { BsArchiveFill } from 'react-icons/bs';
import WorkspaceOptions from './WorkspaceOptions';
import { CustomTip } from '../../helpers/CustomTip';
import ReactTooltip from 'react-tooltip'
import Dropdown from '../../components/Dropdown';
import useToastify from '../../helpers/useToastify';
import SuccessErrorToast from '../../components/Notifications/SuccessErrorToast';

// import RecentIcon from './recent.svg'

const { GlobalState } = require('reflux')


interface Props {
	skip_reload: boolean,
	callStatus?: string
}

function WorkspaceSelector(props: Props) {
	const [snr, setSNR] = useState<any>([])
	const [fetching, setFetching] = useState<boolean>(false)
	const [searchFilter, setSearchFilter] = useState<string>('')
	const [collapsedSpaces, setCollapsedSpaces] = useState<any>(localStorage.getItem('collapsedSpaces') ? JSON.parse(localStorage.getItem('collapsedSpaces') as string) : [])
	const [currentSpace, setCurrentSpace] = useState<string>('')
	const [addingRoom, setAddingRoom] = useState<boolean>(false)
	const [addingSpace, setAddingSpace] = useState<boolean>(false)
	const [deletingSpace, setDeletingSpace] = useState<boolean>(false)
	const [spaceDeleting, setSpaceDeleting] = useState<string>('')
	const [addingRoomInSpace, setAddingRoomInSpace] = useState<string>('')
	const [status, setStatus] = useState<string>('')
	const [user, setUser] = useState<any>(null)
	const [meetingData, setMeetingData] = useState<any>(null)
	const [currentlyOpenMenu, setCurrentlyOpenMenu] = useState<string>('')
	const [selectedOrg, setSelectedOrg] = useState<any>('All')

	let history = useHistory()

	// force refresh for react-beautiful-dnd
	const [, updateState] = useState<any>();
	const forceUpdate = useCallback(() => updateState({}), []);

	useEffect(() => {
		setFetching(true)
		fetchSpacesAndRooms()
	}, [])

	useEffect(() => {
		ReactTooltip.rebuild()
	}, [addingRoom])

	useEffect(() => {
		if (GlobalState.auth?.jwt?.data) {
			setUser(GlobalState.auth?.jwt?.data)
            const orgs = GlobalState.auth.jwt.data.organizations || []
            if(!Array.isArray(orgs)) return
            if(Array.isArray(orgs) && orgs.length === 0) return


			const selOrg: any = localStorage.getItem('selected_organization')
			const parsedSelOrg = isJSON(selOrg) ? JSON.parse(selOrg) : {}
            const lorg = parsedSelOrg?.[GlobalState?.auth?.jwt?.data?._id] || null

            if(lorg && !!orgs.find(o => o.organization?._id === lorg)) {
                setSelectedOrg(lorg)
            } else if(lorg === 'personal') {
				setSelectedOrg('personal')
			} else if(lorg === 'All') {
				setSelectedOrg('All')
			} else {
                setSelectedOrg('All')
            }
		}
	}, [GlobalState.auth?.jwt?.data])

	useEffect(() => {
		if (GlobalState.main?.db_meeting) {
			setMeetingData(GlobalState.main?.db_meeting)
		}
	}, [GlobalState.main?.db_meeting])

	useEffect(() => {
		setStatus(props?.callStatus || '')
	}, [props?.callStatus])

	const fetchSpacesAndRooms = async () => {
		try {
			if(!!!localStorage.getItem('token')) throw new Error('invalid token')
			const orgs = GlobalState.auth.jwt.data.organizations || []

			const selOrg: any = localStorage.getItem('selected_organization')
			const parsedSelOrg = isJSON(selOrg) ? JSON.parse(selOrg) : {}
            const lorg = parsedSelOrg?.[GlobalState?.auth?.jwt?.data?._id] || null
			
			let sOrg = null

            if(lorg && !!orgs.find((o: any) => o?.organization?._id === lorg)) {
                sOrg = lorg
            } else if(lorg === 'personal' ){
                sOrg = 'personal'
            } else if(lorg !== 'All'){
                sOrg = 'All' || null
            } 
			
			const response = await LoopApi(null, 'GetRoomAndSpaces', {organizationId: sOrg === 'All' ? null : sOrg})
			setFetching(false)
			setAddingSpace(false)
			setAddingRoom(false)
			setDeletingSpace(false)
			setAddingRoomInSpace('')
			setSpaceDeleting('')
			setSNR(response)
		} catch (e) {
			setFetching(false)
			setAddingSpace(false)
			setDeletingSpace(false)
			setAddingRoomInSpace('')
			setSpaceDeleting('')
			setAddingRoom(false)
			console.error(e)
		}
	}

	const addRoomToSpace = async (id: string, meetingId: string, position: number) => {
		try {
			const response = await LoopApi(null, 'AddRoomToSpace', { meetingId, position }, [['id', id || 'global']])
			setFetching(false)
		} catch (e) {
			setFetching(false)
			console.error(e)
		}
	}

	const updateSpaceRoomPosition = async (id: string, meetingIds: any) => {
		try {
			const response = await LoopApi(null, 'UpdateSpaceRoomPosition', { meetingIds }, [['id', id]])
			setFetching(false)
		} catch (e) {
			setFetching(false)
			console.error(e)
		}
	}

	const handleSearch = (keyword: string) => {
		setSearchFilter(keyword)
	}

	const onDragEnd = (result: any) => {
		const { source, destination } = result;

		// dropped outside the list
		if (!destination) {
			return;
		}

		if (source.droppableId === destination.droppableId) {
			if (source.index === destination.index) return

			const sourceInd = snr.findIndex((s: Meeting) => (s?._id || 'general') === source.droppableId)
			const src: any = snr.find((s: Meeting) => (s?._id || 'general') === source.droppableId)

			// const meetingIds: any = swapArrayElements(
			// 	src?.meetingIds || [],
			// 	source.index,
			// 	destination.index
			// )

			const meetingIds: any = rearrangeElements(
				src?.meetingIds || [],
				source.index,
				destination.index,
				src?.meetingIds[source.index]
			)

			const item: any = { ...src, meetingIds }
			const items: any = snr
			items[sourceInd] = item

			updateSpaceRoomPosition(source.droppableId, meetingIds)
			forceUpdate()
			setSNR(items)
		} else {
			const sourceInd = snr.findIndex((s: Meeting) => (s?._id || 'general') === source.droppableId)
			const src: any = snr.find((s: Meeting) => (s?._id || 'general') === source.droppableId)
			const destinationInd = snr.findIndex((s: Meeting) => (s?._id || 'general') === destination.droppableId)
			const dst: any = snr.find((s: Meeting) => (s?._id || 'general') === destination.droppableId)

			const result: any = moveElementToOtherArray(
				src?.meetingIds || [],
				dst?.meetingIds || [],
				source,
				destination
			);

			const srcItem: any = { ...src, meetingIds: result.source }
			const dstItem: any = { ...dst, meetingIds: result.destination }

			const items: any = snr
			items[destinationInd] = dstItem
			items[sourceInd] = srcItem

			addRoomToSpace(dst?._id, dst?.meetingIds[destination.index]?._id, destination.index)
			forceUpdate()
			setSNR(items)
		}
	};

	const onAddNewSpace = async () => {
		setAddingSpace(true)
		ModalActions.SetModalWithParams('CreateSpace', { onSubmit, onModalClose: () => { setAddingSpace(false) } })
	}

	const onDeleteSpace = (id: string) => {
		setDeletingSpace(true)
		setSpaceDeleting(id)

		const savedorgs = GlobalState.auth.jwt?.data?.organizations || []
		const uniqueIds: any = [];
		const organizations = savedorgs.filter((o: any, index: number) => {
			const isDuplicate = uniqueIds.includes(o?.organization?._id);
			if (!isDuplicate) {
				uniqueIds.push(o?.organization?._id);
			
				return true;
			}
			return false;
		})

		let ORGANIZATIONS = [] as any

		if(user?.role === 'user') {
			ORGANIZATIONS = [
				...ORGANIZATIONS,
				{
					name: "My personal rooms",
					value: "personal"
				}
			]
		}

		ORGANIZATIONS = [
			...ORGANIZATIONS,
			...organizations.map((o: any) => ({
				name:o.organization?.name,
				value: o.organization?._id
			}))
		] as any


		ModalActions.SetModalWithParams('DeleteSpace', {
			onModalClose: () => { setDeletingSpace(false); setSpaceDeleting('') }, shownote: ORGANIZATIONS.length > 1, onSubmit: async () => {
				try {
					const response = await LoopApi(null, 'DeleteSpace', {}, [['id', id]])
					if (JSON.parse(response)?.success) {
						// setFetching(true)
						fetchSpacesAndRooms()
					}
				} catch (e) {
					setDeletingSpace(false)
					setSpaceDeleting('')
					//console.log(e)
				}
			}
		})
	}

	const onAddNewRoomInSpace = async (space_id: string) => {
		setAddingRoomInSpace(space_id)
		setAddingRoom(true)
		const orgs = GlobalState.auth.jwt?.data?.organizations || []

		ModalActions.SetModalWithParams('CreateRoomInSpace', { selectedOrg: selectedOrg === 'All' && orgs.length > 0  ? orgs[0]?.organization?._id || null :  selectedOrg === 'personal' ? 'personal' : selectedOrg, onSubmit, space_id: space_id || 'global', onModalClose: () => {
             setAddingRoom(false);
             setAddingRoomInSpace('')
             forceUpdate()
		} })
    }

	const onSubmit = (response: any) => {
		if (response.success || response.meeting) {
			// setFetching(true)
			fetchSpacesAndRooms()
		}
	}

	const onSpaceExpand = (id: string) => {
		let localCollapasedSpaces: any = []
		if (localStorage.getItem('collapsedSpaces')) {
			localCollapasedSpaces = JSON.parse(localStorage.getItem('collapsedSpaces') as string);
		}

		if (!collapsedSpaces?.includes(id) || !localCollapasedSpaces?.includes(id)) return

		const newCollapsedSpaces = (collapsedSpaces || []).filter((c: string) => c !== id)
		const newLocalCollapsedSpaces = (localCollapasedSpaces || [])?.filter((c: string) => c !== id)

		localStorage.setItem('collapsedSpaces', JSON.stringify(newLocalCollapsedSpaces))
		setCollapsedSpaces(newCollapsedSpaces)
		forceUpdate()
	}

	const onSpaceCollapse = (id: string) => {
		const newCollapsedSpaces = collapsedSpaces || []
		let collapasedSpaces: any = []
		if (localStorage.getItem('collapsedSpaces')) {
			collapasedSpaces = JSON.parse(localStorage.getItem('collapsedSpaces') as string);
		}

		if (newCollapsedSpaces?.includes(id) || collapasedSpaces?.includes(id)) return

		newCollapsedSpaces.push(id)
		localStorage.setItem('collapsedSpaces', JSON.stringify(newCollapsedSpaces))
		collapasedSpaces.push(id)
		setCollapsedSpaces(newCollapsedSpaces)
		forceUpdate()
	}

	const CreateNewWorkspace = () => {
		// history.push('#create')
		ModalActions.SetModalWithParams("create-or-join", {
			cb: () => {
				fetchSpacesAndRooms()
			},
			isJoin: false
		})
	}

	const connectToMeeting = () => {
		ModalActions.SetModalWithParams('create-or-join', {
			isJoin: true
		})
	}

	const SetMeetingAvatar = () => {
		ModalActions.SetModalWithParams('SetMeetingAvatar', {
			cb: () => {
				fetchSpacesAndRooms()
			}
		})
	}

	const LeaveMeeting = () => {
		//console.log("GlobalState?.main: ", GlobalState?.main?.db_meeting?.name)
		ModalActions.SetModalWithParams('LeaveMeeting', { meetingName: GlobalState?.main?.db_meeting?.name_alias || GlobalState?.main?.meetingName, meetingId: GlobalState?.main?.db_meeting?.name })
	}

	const onSpaceNameFocus = (e: any) => {
		if (!currentSpace) setCurrentSpace(e.target.value)
	}

	const onSpaceNameBlur = async (id: string, e: any) => {
		if (`${e.target.value}` !== `${currentSpace}` && !!e.target.value.trim().length) {
			try {
				const response = await LoopApi(null, 'UpdateSpaceName', { name: `${e.target.value.trim()}` }, [['id', id]])
				if (response.success) {
					setCurrentSpace('')
				}
			} catch (e) {
				//console.log(e)
			}
		} else if(!!!e.target.value.trim().length) {
			e.target.value = e.target.defaultValue
			useToastify({
				message: () => SuccessErrorToast({ message: 'Empty space name is not allowed', type: 'error' }),
				position: "top-right",
				autoClose: 1500,
				closeButton: false,
				hideProgressBar: true,
				className: GlobalState?.theming?.color_scheme === 'Light' ? 'toastL' : 'toastD',
				bodyClassName: "grow-font-size",
			})
		}
	}

	const onSpaceNameKeyDown = (e: any) => {
		if(e.key === 'Enter') {
			const current = e.currentTarget
			current.blur()
			current.classList.add('remove-hover-container')
		}
	}

	const onMouseLeave = (e: any) => {
		const currentClassList = e.currentTarget.classList
		if(currentClassList.contains('remove-hover-container'))
		currentClassList.remove('remove-hover-container')
	}

	const filteredSNR = snr.filter((s: any) => {
		const filteredSpaces = s.meetingIds
			.filter((meeting: any) => {
				if(meeting?.name_alias) {
					return meeting.name?.toLowerCase() === searchFilter.toLowerCase() ||
					meeting.name_alias.toLowerCase().includes(searchFilter.toLowerCase())
				}
				return meeting.name?.toLowerCase().includes(searchFilter.toLowerCase())
			})
		return filteredSpaces?.length > 0 || s.name?.toLowerCase().includes(searchFilter.toLowerCase())
	}).map((s: any) => {
		return {
			...s,
			meetingIds: s.name?.toLowerCase().includes(searchFilter.toLowerCase()) ? s.meetingIds :
			s.meetingIds.filter((m: any) => m?.name?.toLowerCase().includes(searchFilter.toLowerCase()) ||
			m?.name_alias.toLowerCase().includes(searchFilter.toLowerCase()))
		} 
	})

	const updateCurrentlySelectedMenu = (e: any, meetingId: string) => {
		e.stopPropagation()
		setCurrentlyOpenMenu(meetingId)
	}

    const handleOrgChange = (item: any, name: any) => {
        localStorage.setItem('selectedorg', item.value)
		const selOrg: any = localStorage.getItem('selected_organization')
		const parsedSelOrg = isJSON(selOrg) ? JSON.parse(selOrg) : {}
		const newParseSelOrg = {
			...parsedSelOrg,
			[GlobalState?.auth?.jwt?.data?._id]: item.value
		}

		localStorage.setItem('selected_organization', JSON.stringify(newParseSelOrg))
        setSelectedOrg(item.value)
		fetchSpacesAndRooms()
    }


	const list = (searchFilter ? filteredSNR : snr).map((items: Meeting) => {
		return <React.Fragment>
			{items.name && <SpaceName key={items?._id}>
				<SpaceLeft>
					{
						(collapsedSpaces || [])?.includes(items?._id) ?
							<CollapsedIcon className="folder-action" title="Expand space" {...{ onClick: () => onSpaceExpand(items?._id || '') }} /> :
							<ExpandedIcon className="folder-action" title="Collapse space" {...{ onClick: () => onSpaceCollapse(items?._id || '') }} />
					}
					<SpaceIcon className="space-icon" />
					<div className="label">
						<input
							type="text"
							defaultValue={`${items.name}`}
							className="hover-container border-light topbar"
							onFocus={onSpaceNameFocus}
							onBlur={(e: any) => onSpaceNameBlur(items?._id || '', e)}
							onKeyDown={(e: any) => onSpaceNameKeyDown(e)}
							onMouseLeave={(e: any) => onMouseLeave(e)}
						/>
						{
							items?.meetingIds?.filter((meeting) => !!!meeting.archived)?.length ?
							<React.Fragment>
								<div style={{ cursor: 'default' }} data-tip data-for={items?._id}>({(items?.meetingIds?.filter((meeting) => !!!meeting.archived)?.length)})</div>
							</React.Fragment> : ''
						}
						<CustomTip top={-30} left={10} class='top-left' place='right' tip={
							<RoomTooltipWrapper>
								<div>Number of rooms</div>
								<div>{items?.meetingIds?.filter((meeting) => !!!meeting.archived && meeting.creator_user_id === user?._id)?.length} - Total created rooms</div>
							</RoomTooltipWrapper>

						} dataFor={items?._id} />
						{
							addingRoom && addingRoomInSpace === items?._id ? <LoadingIcon className="new-room-icon loading" /> :
								<NewRoomIcon className="color-primary new-room-icon" data-tip data-for='add-room' onClick={() => onAddNewRoomInSpace(items?._id || '')} />

						}
						<CustomTip top={-20} left={10} class='top-left' place='right' tip='Add New Room' dataFor='add-room' />
					</div>
					{/* <SpaceRight>

					</SpaceRight> */}
				</SpaceLeft>
			</SpaceName>} {/* space icon */}
			{
				!!!items?.name && <SpaceName key={items?._id || 'global'} className="general-room-wrapper">
					<SpaceLeft>
						<Header className="room-title">
							Rooms &nbsp; {items?.meetingIds?.filter((meeting) => !!!meeting.archived)?.length && <span style={{ cursor: 'default' }} data-for='room-count' data-tip>({items?.meetingIds?.filter((meeting) => !!!meeting.archived)?.length})</span>}
						</Header>
						<CustomTip top={-20} left={10} class='top-left' place='right' tip={
							<RoomTooltipWrapper>
								<div>Number of rooms</div>
								<div>{items?.meetingIds?.filter((meeting) => !!!meeting.archived && meeting.creator_user_id === user?._id)?.length} - Total created rooms</div>
							</RoomTooltipWrapper>

						} dataFor='room-count' />
					</SpaceLeft>
					<SpaceRight>
						{
							addingRoom && !!!addingRoomInSpace ? <LoadingIcon className="new-room-icon loading" /> :
								<NewRoomIcon className="color-primary new-room-icon" data-tip data-for='add-room' onClick={() => onAddNewRoomInSpace(items?._id || '')} />
						}
					</SpaceRight>
				</SpaceName>
			}
			<Droppable droppableId={items?._id || 'general'}>
				{
					(provided, snapshot) => (
						<DroppableWrapper ref={provided.innerRef} {...provided.droppableProps} {...{ isDraggingOver: snapshot.isDraggingOver }}
							style={getListStyle(snapshot.isDraggingOver, GlobalState.theming.color_scheme || 'Light', (collapsedSpaces || [])?.includes(items?._id))}>
							{
								items.meetingIds?.length ? items.meetingIds.filter((meeting) => !!!meeting.archived).map((meeting, index) => {
									const current = GlobalState?.main?.db_meeting?.name === meeting.name
									return <Draggable
										key={meeting._id}
										draggableId={meeting._id}
										index={index}>
										{(provided, snapshot) => (
											<WorkspaceItem
												ref={provided.innerRef}
												{...provided.draggableProps}
												{...provided.dragHandleProps}
												style={getItemStyle(
													snapshot.isDragging,
													provided.draggableProps.style,
												)}
												onClick={() => {
													if (!current && GlobalState?.main?.db_meeting?.name) {
														return ModalActions.SetModalWithParams("TransferRoom", {
															room: meeting.name, roomName: meeting.name_alias, cb: () => {
																!props.skip_reload && window.location.reload()
															}
														})
													}

													if (!!!GlobalState?.main?.db_meeting?.name) {
														history.push(`/${meeting.name}`)
														!props.skip_reload && window.location.reload()
														ModalActions.SetModal('')
													}

												}}
											>
												<WorkspaceAvatar>
													<img src={meeting?.avatar_url || `https://ui-avatars.com/api/?name=${meeting?.name_alias || meeting?.name || 'Room'}&background=${(GlobalState?.main?.setupPhase === 'archived' ? 'Light' : GlobalState.theming.color_scheme || 'Light') === 'Light' ? 'F2F4F6' : '21212B&color=FEFEFE'}&format=svg`} alt={meeting.name_alias || meeting.name} />
												</WorkspaceAvatar>
												<div className={`label ${meeting?.name === GlobalState?.main?.db_meeting?.name ? 'color-primary' : ''}`} style={{ textDecoration: meeting.archived ? 'line-through' : '' }}>
													<div>{meeting.name_alias || meeting.name} {meeting.archived ? '(archived)' : null}</div>
													{meeting?.creator_user_id && <div className={`${meeting?.name === GlobalState?.main?.db_meeting?.name ? 'color-primary' : ''}`} style={{ fontSize: '10px', display: 'flex', alignItems: 'center' }}><UserIcon style={{ marginRight: '5px' }}/> {meeting?.creator_user_id === user?._id ? 'Me' : meeting?.creator_user_name}</div>}
												</div>
												<div className="more-option" key={`${meeting._id}-options`} onClick={(e) => {
													e.stopPropagation()

													// if(currentlyOpenMenu === meeting._id) {
													// 	return setCurrentlyOpenMenu('')
													// }
													// setCurrentlyOpenMenu(meeting._id)
												}}>
													<Tooltip
														// visible={currentlyOpenMenu === meeting._id}
														overlay={
															<WorkspaceOptions
																meetingData={meetingData}
																user={user}
																call_status={status}
																color_scheme={GlobalState?.theming?.color_scheme}
																meeting={meeting}
																fetchSpacesAndRooms={fetchSpacesAndRooms}
															/>
														}
														placement="bottomRight"
														trigger={['click']}
														overlayClassName={`workspace-dropdown rctooltip${(GlobalState.theming.color_scheme || 'Light') === 'Light' ? 'L' : 'D'}`}
													>
														<div>
															<MoreOptionsIcon size={20} />
														</div>
													</Tooltip>

												</div>

											</WorkspaceItem>
										)}
									</Draggable>
								}) : items?._id ? <React.Fragment>
									<NoRooms className="no-room">No rooms in this space</NoRooms>
									{
										deletingSpace && spaceDeleting === items?._id ? <div className="loading delete-space-loader"><LoadingIcon /></div> :
											<div className="delete-space" onClick={() => onDeleteSpace(items?._id || '')}>REMOVE</div>
									}
								</React.Fragment> : <NoRooms className="no-room-in-general">No rooms</NoRooms>
							}
							{provided.placeholder}
						</DroppableWrapper>
					)
				}
			</Droppable>
		</React.Fragment>
	})

    const Organization = () => {
        const savedorgs = GlobalState.auth.jwt?.data?.organizations || []
		const uniqueIds: any = [];
		const orgs = savedorgs.filter((o: any, index: number) => {
			const isDuplicate = uniqueIds.includes(o?.organization?._id);
			if (!isDuplicate) {
				uniqueIds.push(o?.organization?._id);
			
				return true;
			}
			return false;
		})
        //console.log(GlobalState.auth)
        if(!Array.isArray(orgs)) return <></>
        if(Array.isArray(orgs) && orgs.length === 0) return <></>
        if(!orgs[0]?.organization?._id) return <></>;

		let ORGANIZATIONS = [] as any

		if(orgs.length >= 1 && user?.role === 'user' || orgs.length > 1) {
			ORGANIZATIONS = [
				{
					name: "All Rooms",
					value: "All"
				}
			]
		} 

		if(user?.role === 'user') {
			ORGANIZATIONS = [
				...ORGANIZATIONS,
				{
					name: "My personal rooms",
					value: "personal"
				}
			]
		}

		ORGANIZATIONS = [
			...ORGANIZATIONS,
			...orgs.map((o) => ({
				name:o.organization?.name,
				value: o.organization?._id
			}))
		] as any
		


        return (
          <OrganizationWrapper>
			<Dropdown
				name="selectedOrg"
				value={selectedOrg}
				items={ORGANIZATIONS}
				inputWidth={120}
				onChange={handleOrgChange}
			/>
            {/* <select onChange={handleOrgChange}>
				<option value={'All'} selected={selectedOrg === 'All' ? true : false}>All</option>
              {orgs.map((o: any) => {
                return <option value={o.organization?._id} selected={selectedOrg === o.organization?._id ? true : false}>{o.organization?.name}</option>
              })}
            </select> */}
          </OrganizationWrapper>
        )
    }
	const orgs = GlobalState.auth.jwt?.data?.organizations || []

	console.log({ status })

	return (
		<React.Fragment>
			{Array.isArray(orgs) && orgs.length > 0 && 
				<div style={{
					fontWeight: 500,
					fontSize: '12px',
					marginBottom: '10px'
				}}>Select Organization</div>
			}
            <Organization />
			<FormFieldWrapper className="button border-light" style={{ padding: '8px 12px' }}>
				<span className="password-view"><SearchIcon /></span>
				<input type="text" onChange={(e) => handleSearch(e.target.value)} className="topbar"  placeholder='Search'/>
			</FormFieldWrapper>
			<Header className="header-title">
				<div className="label">Spaces</div>
				{
					addingSpace ?
						<div className="new-space loading"><LoadingIcon size={16} /></div> :
						<div className="color-primary new-space" onClick={onAddNewSpace} data-tip data-for='add-space'><NewSpaceIcon size={20} /></div>
				}
				<CustomTip top={-20} left={0} class='top-left' place='right' tip='Add New Space' dataFor='add-space' />

			</Header>
			<Container staggerDelayBy={20} className="border-light">
				{
					fetching ? <LoadingComponent /> :
						<DragDropContext onDragEnd={onDragEnd}>
							{list}
						</DragDropContext>
				}
			</Container>
			<Bottom>
				<StyledMeeting
                    small
					onClick={() => ModalActions.SetModal('RecentRooms')}
				>
					<IconWrapper>
						<RecentIcon width={20} />
						{/* <img src={RecentIcon} style={{height: '20px'}}/> */}
					</IconWrapper>
					<p>Recent Rooms</p>
				</StyledMeeting>
				<StyledMeeting onClick={() => onAddNewRoomInSpace('')} small>
					<IconWrapper>
						<SpaceIcon size={20} />
					</IconWrapper>
					<p>New Room</p>
				</StyledMeeting>
				<StyledMeeting
					onClick={status !== CallingInstanceState.UninitializedWithoutToken && status !== CallingInstanceState.Disconnected ? () => { } : connectToMeeting}
					small
					disabled={status !== CallingInstanceState.UninitializedWithoutToken && status !== CallingInstanceState.Disconnected}
				// title={status !== CallingInstanceState.UninitializedWithoutToken ? 'Leave the meeting to join a room' : 'Join Room'}
				>
					<IconWrapper>
						<UsersIcon size={20} />
					</IconWrapper>
					<p>Join Room</p>
				</StyledMeeting>
				{/* <StyledMeeting onClick={GlobalState?.main?.meetingName === null ? () => {} : SetMeetingAvatar} small disabled={GlobalState?.main?.meetingName === null}>
					<IconWrapper>
						<EditIcon />
					</IconWrapper>
					<p>Set Room Icon</p>
				</StyledMeeting> */}
				<StyledMeeting
					// onClick={GlobalState?.main?.meetingName === null || status !== CallingInstanceState.UninitializedWithoutToken ? () => {} : LeaveMeeting}
					small
					// disabled={GlobalState?.main?.meetingName === null || status !== CallingInstanceState.UninitializedWithoutToken}
					// title={status !== CallingInstanceState.UninitializedWithoutToken ? 'Leave the meeting to remove this room' : 'Remove Room'}
					onClick={() => ModalActions.SetModalWithParams('ArchiveRooms', { fetchSpacesAndRooms })}
				// title="Archived Rooms"
				>
					<IconWrapper>
						<SpaceIcon size={20} />
						<XLine className="bg-textColor" />
					</IconWrapper>
					{/* <p>{meeting?.creator_user_id === user?._id ? 'Archive' : 'Remove'} Room</p> */}
					<p>Archived Rooms</p>
				</StyledMeeting>
				{/* <a title="Show Archive" href="#" onClick={() => ModalActions.SetModal('ArchiveRooms')}><BsArchiveFill size={18} color='red' style={{ marginRight: 5 }} /></a> */}
			</Bottom>
		</React.Fragment>
	)
}

const NewSpaceIcon = ({ size }: any) => {
	return (
		<svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M20.3125 16.625H18.75V19.75H15.625V21.3125H18.75V24.4375H20.3125V21.3125H23.4375V19.75H20.3125V16.625Z" fill="currentColor" />
			<path d="M21.875 6.25H12.5L9.84375 3.59375C9.53125 3.28125 9.14062 3.125 8.75 3.125H3.125C2.26562 3.125 1.5625 3.82812 1.5625 4.6875V20.3125C1.5625 21.1719 2.26562 21.875 3.125 21.875H14.0625V20.3125H3.125V4.6875H8.75L11.4062 7.34375L11.875 7.8125H21.875V14.0625H23.4375V7.8125C23.4375 6.95312 22.7344 6.25 21.875 6.25Z" fill="currentColor" />
		</svg>
	)
}

const RecentIcon = ({ size }: any) => {
	return (
		<svg width="22" height={size} viewBox="0 0 27 25" className='svg-stroke svg-fill' fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill='none' d="M3 9H21" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
		<path fill='none' d="M9 21V9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M3.75 5C3.75 4.30964 4.30964 3.75 5 3.75H19C19.6904 3.75 20.25 4.30964 20.25 5V12.0047C20.3329 12.0016 20.4163 12 20.5 12C20.9276 12 21.3455 12.0413 21.75 12.1201V5C21.75 3.48122 20.5188 2.25 19 2.25H5C3.48122 2.25 2.25 3.48122 2.25 5V19C2.25 20.5188 3.48122 21.75 5 21.75H14.8696C14.5998 21.2835 14.3862 20.7804 14.2383 20.25H5C4.30964 20.25 3.75 19.6904 3.75 19V5Z"/>
		<path d="M20.0289 12.5188C21.2403 12.4233 22.4521 12.6979 23.504 13.3061C24.5559 13.9144 25.3983 14.8277 25.9198 15.9252C26.4413 17.0228 26.6173 18.2528 26.4244 19.4525C26.2316 20.6522 25.679 21.7651 24.8399 22.6439C24.0007 23.5227 22.9145 24.126 21.7249 24.374C20.5354 24.622 19.2986 24.5029 18.1782 24.0326C17.0578 23.5623 16.1066 22.7629 15.4504 21.7401C14.7943 20.7174 14.4641 19.5195 14.5037 18.3051C14.5059 18.2312 14.5226 18.1585 14.5529 18.0911C14.5833 18.0237 14.6266 17.9629 14.6803 17.9123C14.7341 17.8616 14.7974 17.822 14.8665 17.7958C14.9356 17.7696 15.0092 17.7572 15.083 17.7594C15.1569 17.7616 15.2296 17.7784 15.297 17.8087C15.3644 17.839 15.4252 17.8823 15.4758 17.9361C15.5265 17.9899 15.5661 18.0532 15.5923 18.1223C15.6185 18.1914 15.6309 18.2649 15.6287 18.3388C15.5907 19.4885 15.9604 20.6145 16.6725 21.5179C17.3846 22.4212 18.3932 23.0437 19.5199 23.2751C20.6466 23.5066 21.8189 23.3323 22.8295 22.7828C23.8401 22.2334 24.6238 21.3444 25.0422 20.2729C25.4605 19.2014 25.4865 18.0164 25.1155 16.9276C24.7445 15.8388 24.0005 14.9163 23.015 14.3231C22.0294 13.7299 20.8659 13.5043 19.7301 13.6862C18.5943 13.8681 17.5594 14.4458 16.8084 15.3171L16.6554 15.5031H18.4397L18.5162 15.5091C18.6508 15.5276 18.7742 15.5942 18.8635 15.6967C18.9528 15.7991 19.002 15.9304 19.002 16.0663C19.002 16.2022 18.9528 16.3335 18.8635 16.436C18.7742 16.5384 18.6508 16.605 18.5162 16.6236L18.4397 16.6288H15.4397L15.3632 16.6236C15.2416 16.6069 15.1287 16.5508 15.0419 16.464C14.9551 16.3772 14.8991 16.2644 14.8824 16.1428L14.8772 16.0663V13.0663L14.8824 12.9898C14.8991 12.8682 14.9551 12.7554 15.0419 12.6686C15.1287 12.5818 15.2416 12.5258 15.3632 12.5091L15.4397 12.5038L15.5162 12.5091C15.6378 12.5258 15.7506 12.5818 15.8374 12.6686C15.9242 12.7554 15.9802 12.8682 15.9969 12.9898L16.0022 13.0663L16.0014 14.5311C17.0308 13.3618 18.4757 12.6394 20.0289 12.5188ZM20.3124 15.5031L20.3889 15.5083C20.5105 15.525 20.6233 15.581 20.7101 15.6678C20.7969 15.7546 20.853 15.8674 20.8697 15.9891L20.8749 16.0656V18.4993L22.1874 18.5001L22.2639 18.5053C22.3991 18.5232 22.5232 18.5897 22.6131 18.6922C22.703 18.7948 22.7525 18.9265 22.7525 19.0629C22.7525 19.1993 22.703 19.3311 22.6131 19.4336C22.5232 19.5362 22.3991 19.6026 22.2639 19.6206L22.1874 19.6251H20.3124L20.2359 19.6206C20.1142 19.6038 20.0013 19.5477 19.9145 19.4607C19.8277 19.3738 19.7717 19.2608 19.7552 19.1391L19.7499 19.0626V16.0656L19.7552 15.9891C19.7719 15.8674 19.8279 15.7546 19.9147 15.6678C20.0015 15.581 20.1143 15.525 20.2359 15.5083L20.3124 15.5031Z"/>
		</svg>


	)
}

export default WorkspaceSelector
